/**
 * @module apps/mortgage_inquiry_form
 */

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { createStore, Store, combineReducers, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'

import setupAxios from '@utilities/setupAxios'
import { sentryMiddleware } from '@utilities/sentry'
import {
  reducer as inquiriesReducer,
  loadInquiry,
  requestInquiry,
  IInquiry
} from '@features/inquiries'

import App from './App'

// Window
setupAxios()

const CONTAINER_EL = document.getElementById('mortgage_inquiry_form')

class Main extends Component {
  store: Store

  constructor(props: {}) {
    super(props)

    const reducer = combineReducers({
      inquiries: inquiriesReducer
    })

    let middleware: any = []

    // process.env provided by Webpack DefinePlugin
    if (process.env.NODE_ENV === 'production') {
      middleware.push(sentryMiddleware({ logState: true }))
    }

    this.store = createStore(reducer, composeWithDevTools(applyMiddleware(...middleware)))

    // Load initial state
    this.store.dispatch(
      loadInquiry({
        calculatorId: 'MORTGAGE_INQUIRY',
        status: 'NOT_STARTED',
        user: null,
        deposit: null,
        num_dependants: 0,
        primary_applicant: {
          annual_gross_income: null
        }
      })
    )
  }

  requestInquiry = (calculatorId: string, inquiry: IInquiry) => {
    return requestInquiry(this.store.dispatch, calculatorId, inquiry)
  }

  render() {
    return (
      <Provider store={this.store}>
        <App requestInquiry={this.requestInquiry} />
      </Provider>
    )
  }
}

ReactDOM.render(<Main />, CONTAINER_EL)
